app.directive('personalDetailsRegulated', [function () {
    return {
        templateUrl: 'templates/directives/personalDetailsRegulated.html'
    }
}]);
